package org.multiplatform.kotfolio.pages.flutter

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties

@Page("/flutter/getx")
@Composable
fun getXPage() {
    BlogLayout(
        PageProperties(
            "GetX",
            "GetX is designed to be fast, lightweight, high-performance and reactive state management approach."
        ),
        BlogProperties("Flutter", "GetX State Management")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "GetX is a helpful tool for Flutter. It makes it easy to manage states, and routing and can efficiently perform dependency injection.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Ol {
                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "GetX is designed to be fast, lightweight and high-performance, and doesn’t use things like Streams or ChangeNotifier, which helps your app run smoothly and use less device power.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .textAlign(TextAlign.Start)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "GetX lets you separate and manage View, logic, dependencies, and navigation easily.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .textAlign(TextAlign.Start)
                        )
                    }
                }
            }

            SpanText(
                text = "Add plugin",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "https://pub.dev/packages/get ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            SpanText(
                text = "Advantages",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "StreamController: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )

                    SpanText(
                        text = "Not necessary to create a StreamController.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Not necessary to create a StreamController: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )

                    SpanText(
                        text = "There is no requirement to create a Stream Builder.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "state: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )

                    SpanText(
                        text = "No requirement to create a class for each state.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Initial value: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )

                    SpanText(
                        text = "There is no need to create an initial value.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            SpanText(
                text = "When it comes to state management GetX has two different approaches:",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Reactive state management: Obx(), GetX()",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Simple state management: GetBuilder()",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The core idea is to make parts of your app’s state observable and automatically update the UI whenever that state changes.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The primary components for state management in GetX are:",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Ol {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Obx and GetBuilder: These widgets allow you to create reactive parts of your UI that update automatically when the observed state changes.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .textAlign(TextAlign.Start)
                        )
                    }

                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Rx: The Rx library is at the heart of GetX’s reactivity. It provides observables, reactive streams, and utility methods for handling reactive data.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .textAlign(TextAlign.Start)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "GetX: We can skip StatefulWidgets, save RAM, avoid initState(), and keep our code clean and organized with separate controllers for business logic and automatic view updates.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .textAlign(TextAlign.Start)
                        )
                    }
                }
            }

            SpanText(
                text = "What is the difference between obx and GetBuilder?",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "GetBuilder when you need to manually update a widget’s state from your controller using ‘update()’.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Obx when you want a widget to automatically update based on changes in an observable variable marked with ‘obs’, ensuring real-time updates in your app.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            KotlinCode(
                code = """
                    //observable / reactive data type
                    
                    RxString name = ''.obs;
                    
                    RxInt number = 0.obs;
                    
                    RxDouble double = 0.0.obs;
                    
                    RxBool isBool = false.obs;
                    
                    RxList _list = [].obs;
                    """.trimIndent()
            )

            SpanText(
                text = "Route (Routing) Management",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Named Routes: Easily define and navigate to named routes.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Dynamic Route Transitions: Customize transitions between routes dynamically.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Middleware and Guards: Control route navigation with middleware and guards.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Route Observing: Observe route changes and react accordingly.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Handle the unknown route.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            KotlinCode(
                code = """
                    //Navigate to a next page
                    Get.to(HomePage(), arguments:, transition: Transition.leftToRightWithFade);
                    // OR
                    Get.toNamed("/HomePage");

                    //To go to the next page and no option to go back to the previous page (for use in SplashPage, login Page, etc.)
                    Get.off(HomePage());
                    // OR
                    Get.offNamed("/HomePage");

                    //To go to the next screen and cancel all previous routes (useful in shopping carts, polls, and tests)
                    Get.offAll(HomePage());
                    // OR
                    Get.offAllNamed("/HomePage");

                    //Back to previous page or close snackbar, dialogs...
                    Get.back();
                    """.trimIndent()
            )

            SpanText(
                text = "Parameter Argument",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Parameters are used to pass data directly through the URL. They are part of the route and can be accessed using the Get.parameters map.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            KotlinCode(
                code = """
                     //Argument pass
                     GetPage(name: '/forgotPassword/:mobile', page: () => DetailsScreen()),
                     Get.toNamed('/forgotPassword/1234567890');
                     String id = Get.parameters['mobile'] ?? ''; // Access parameter
                     
                      //Argument pass
                     Get.toNamed("/HomePage", arguments: "Any Argument type");
                     
                     //Get argument
                     var args = Get.arguments;
                """.trimIndent()
            )

            SpanText(
                text = "Snackbar, Dialog, Toast, and Sheets",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    Get.dialog(YourDialog);

                    Get.bottomSheet(YourSheetWidget);
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    import 'package:flutter/material.dart';
                    import 'package:get/get.dart';

                    extension DynamicUtil on dynamic {
                      toast({required String? title, required String? message}) => GetSnackBar(
                            titleText: Text(title!, style: Get.textTheme.headlineMedium!.copyWith(fontSize: 14, fontWeight: FontWeight.w600)),
                            messageText: Text(message!, style: Get.textTheme.displaySmall),
                            snackPosition: SnackPosition.TOP,
                            margin: const EdgeInsets.symmetric(horizontal: 16),
                            overlayBlur: 0,
                            backgroundColor: Get.theme.colorScheme.onErrorContainer.withOpacity(0.1),
                            barBlur: 6,
                            padding: const EdgeInsets.symmetric(horizontal: 15, vertical: 15),
                            borderRadius: 8,
                            dismissDirection: DismissDirection.horizontal,
                            reverseAnimationCurve: Curves.easeIn,
                            forwardAnimationCurve: Curves.easeInBack,
                            duration: 3000.milliseconds,

                            /*snackbarStatus: (status) {
                              if (status == SnackbarStatus.OPEN) {
                                Get.closeCurrentSnackbar();
                              }
                            },*/
                          ).show();
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "Dependency Injection",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "GetX includes its own dependency injection system for managing dependencies and providing them to your classes and widgets. The core concepts include:",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Ol {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Get.create(): When we have to create a new instance of the dependency every time.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .textAlign(TextAlign.Start)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Get.put, Get.lazyPut: Register dependencies for injection.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .textAlign(TextAlign.Start)
                        )
                    }

                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Get.lazyPut(): Use this method when you want to lazily initialize and register a dependency. The dependency will only be created when it’s actually requested for the first time.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .textAlign(TextAlign.Start)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Get.find: Retrieve registered dependencies. Use this method to retrieve a registered dependency. GetX will manage the lifetime of the dependency and ensure that the same instance is returned whenever Get.find is called for the same type. Avoid manually creating instances of dependencies using the new keyword.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .textAlign(TextAlign.Start)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Get.putAsync, Get.lazyPutAsync: Asynchronously initialize dependencies.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .textAlign(TextAlign.Start)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Get.putAsync(): Use this method to register a dependency that needs to be asynchronously created and initialized. It returns a Future, and the dependency will be available once the Future completes.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .textAlign(TextAlign.Start)
                        )
                    }
                }
            }

            KotlinCode(
                code = """
                    Get.create(() => Controller());
                    
                    Get.lazyPut(() => MyService());
                    
                    Get.putAsync(() => Future.delayed(Duration(seconds: 1), () => MyService()));
                    
                    //fenix (true or false)
                    class LoginBinding extends Bindings {
                      @override
                      void dependencies() =>
                          Get.lazyPut(() => LoginController(), fenix: true);
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "Validation",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "GetUtils provides validation methods for performing input validation.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            KotlinCode(
                code = """
                    GetUtils.isPhoneNumber()
                    """.trimIndent()
            )

            SpanText(
                text = "Internationalization (i18n)",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "GetX includes support for internationalization, making it easy to create multilingual applications. It provides tools to manage translations and switch between different languages seamlessly.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            SpanText(
                text = "When to Use Bindings",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "Heavy Initialization: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )

                    SpanText(
                        text = "If a screen requires heavy data loading or resource initialization, using a Binding can help ensure that this work is done before the screen is displayed.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(topBottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "Scoped Dependencies: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )

                    SpanText(
                        text = "When a screen or route requires specific dependencies or controllers that are not used elsewhere, Bindings can provide these scoped instances.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(topBottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "Performance Optimization: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )

                    SpanText(
                        text = "For screens where loading data might take time, Bindings can help improve the app’s perceived performance by preloading data before the UI is shown.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(topBottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "Avoiding Redundant Work: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )

                    SpanText(
                        text = "Bindings can prevent redundant initialization by ensuring that resources are created only when necessary and disposed of properly.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            SpanText(
                text = "GetxController",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Business logic of an app lives inside of a controller and GetX comes with a special class called GetxConroller.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "GetxController that extends DisposableInterface.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "This means that when the widgets that use our controller are removed from the navigation stack, our controller will be destroyed from memory. We don’t need to dispose of anything manually, and memory usage is lowered, resulting in a good performance.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The update() method in GetxController class is responsible for rebuilding the GetBuilder widget.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "GetTickerProviderStateMixin or GetSingleTickerProviderStateMixin is used for animation.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            SpanText(
                text = "GetXController method",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "onInit() which is called when the controller is created. For example, animation initialize, only init the API calling etc.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "onReady() which is called after the widget is rendered on the screen.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "onClose() which is called when the controller is freed from memory.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            KotlinCode(
                code = """
                    class MyController extends GetxController {

                      //rx initial value is recommended, but not mandatory
                      final name = RxString(''); 

                      @override
                      void onInit(){
                        // Get called when controller is created
                        super.onInit();
                      }

                      @override
                      void onReady(){
                        // Get called after widget is rendered on the screen
                        super.onReady();
                      }

                      @override
                      void onClose(){
                        //Get called when controller is removed from memory
                        super.onClose();
                      }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    class SplashController extends GetxController with GetTickerProviderStateMixin {
                      
                      @override
                      void onReady() {
                        //wait some time after navigation write code
                        super.onReady();
                      }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "GetBuilder",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "GetBuilder can be wrapped around any widget to make it communicate with the controller’s methods and variables.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "GetBuilder and to this we pass a controller which is that we already defined, using init we initialize MyController, then we have builder that takes the controller and returns a widget.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            SpanText(
                text = "GetX",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "GetX you pass controller that we want to use. The properties of GetX are init to initialize a controller & builder to define the method which takes controller as parameter and returns a widget.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            SpanText(
                text = "Obx()",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Obx() takes a callback method that returns a widget, here it is Text widget, and inside Text widget we are calling a controller which is controller.h which is observable.value that we want to display on screen.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = ".value is the observalable property.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            SpanText(
                text = "When use .obs why use .value",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Adding .obs to a variable makes it an observable variable and to get the value of an observable variable, you do so from the value property.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            SpanText(
                text = "permanent: true",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Used to for core services (like Auth, API, Theme). These are always alive during the app's lifecycle.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            SpanText(
                text = "fenix: true",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Used to for feature controllers like Dashboard, Profile etc. They're disposed when not in use but auto-recreated when needed again.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            SpanText(
                text = "GetMaterialApp",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "GetMaterialApp is a widget that is a subclass for MaterialApp.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Using this widget is not compulsory if you are using the GetX package only for state management, but if you are using GetX for routing, extends GetView then we need to use GetMaterialApp widget.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            KotlinCode(
                code = """
                    GetMaterialApp(
                              title: titleApp,
                              enableLog: true,
                              key: UniqueKey(),
                              debugShowCheckedModeBanner: false,
                              defaultTransition: Transition.fade,
                              opaqueRoute: Get.isOpaqueRouteDefault,
                              popGesture: Get.isPopGestureEnable,
                              initialRoute: RouteName.slashRoute,
                              getPages: RouteCollection.routeCollection,
                              navigatorKey: Get.key,
                              
                              logWriterCallback: (text, {bool? isError}) { Log.d(text); },
                              
                              //navigatorObservers: [GetObserver()],
                              navigatorObservers: <NavigatorObserver>[observer],
                              
                              //initialBinding: BindingsBuilder(() => Get.lazyPut<GlobalController>(() => GlobalController(Get.find(), Get.find()), fenix: true)),
                             
                              //themeMode: Get.find<GlobalController>().themeName, //Check system theme first time
                             
                              //theme: AppTheme.lightTheme,
                             
                              //darkTheme: AppTheme.darkTheme
                    ));
                    """.trimIndent()
            )

            SpanText(
                text = "GetxService",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "GetX Service is useful to let you make some common functions, you can handle the same lifecycle (onInit(), onReady(), onClose()) as controller, and you can get the service anywhere with Get.find().",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "For example, create a local storage service to handle the SharedPreferences functions.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Socket.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            KotlinCode(
                code = """
                    class LocalStorageService extends GetxService {
                    Future<T?> getValue<T>(
                        LocalStorageKeys key, [
                        T Function(Map<String, dynamic>)? fromJson,
                      ]) async {
                        SharedPreferences prefs = await SharedPreferences.getInstance();
                        switch (T) {
                          case int:
                            return prefs.getInt(key.name) as T?;
                          case double:
                            return prefs.getDouble(key.name) as T?;
                          case String:
                            return prefs.getString(key.name) as T?;
                          case bool:
                            return prefs.getBool(key.name) as T?;
                          default:
                            assert(fromJson != null, 'fromJson must be provided for Object values');
                            if (fromJson != null) {
                              final stringObject = prefs.getString(key.name);
                              if (stringObject == null) return null;
                              final jsonObject = jsonDecode(stringObject) as Map<String, dynamic>;
                              return fromJson(jsonObject);
                            }
                        }
                        return null;
                      }

                      void setValue<T>(LocalStorageKeys key, T value) async {
                        SharedPreferences prefs = await SharedPreferences.getInstance();
                        switch (T) {
                          case int:
                            prefs.setInt(key.name, value as int);
                            break;
                          case double:
                            prefs.setDouble(key.name, value as double);
                            break;
                          case String:
                            prefs.setString(key.name, value as String);
                            break;
                          case bool:
                            prefs.setBool(key.name, value as bool);
                            break;
                          default:
                            assert(
                              value is Map<String, dynamic>,
                              'value must be int, double, String, bool or Map<String, dynamic>',
                            );
                            final stringObject = jsonEncode(value);
                            prefs.setString(key.name, stringObject);
                        }
                      }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //Give name of previous route
                    Get.previousRoute

                    //Give the raw route to access for example, rawRoute.isFirst()
                    Get.rawRoute

                    //Give access to Routing API from GetObserver
                    Get.routing

                    //Check if snackbar is open
                    Get.isSnackbarOpen

                    // check if dialog is open
                    Get.isDialogOpen
                    // check if bottomsheet is open
                    Get.isBottomSheetOpen

                    //Check in what platform the app is running
                    GetPlatform.isAndroid

                    //Equivalent to : MediaQuery.of(context).size.height, but immutable.
                    Get.height
                    Get.width

                    //Gives the current context of the Navigator.
                    Get.context

                    //Gives the context of the snackbar / dialog / bottomsheet in the foreground, anywhere in your code.
                    Get.contextOverlay
                    """.trimIndent()
            )
        }
    }
}